export default class Hotfixes {
    static init() {
        /* remove listitems or other elements on the fly on already generated pages and also in editor when list has not been updated */
        this.removeItems();
    }
    static removeItems() {
        let toRemove = [
            '.module-sectorswidget_OFF [data-preset-id="12"]',
            '.module-brands_OFF [data-preset-id="1"]'
        ];
        toRemove.forEach((toRemove__value) => {
            if (document.querySelector(toRemove__value) !== null) {
                document.querySelectorAll(toRemove__value).forEach((el) => {
                    el.remove();
                });
            }
        });
    }
}
